import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router does not auto-scroll to #hash targets on client-side navigation.
// This watches the location and scrolls to the matching element id when a hash is present.
export default function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      // Delay slightly to allow the target page/section to render first
      const timer = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
      return () => clearTimeout(timer);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return null;
}
